import React, { lazy } from 'react'
import { collectionsAdminAccessControl } from 'domains/collections/access-control/collectionsAdminAccess.configuration'
import { CollectionsAdminListPage } from 'domains/collections/pages/admin/CollectionsAdminListPage'
import { CollectionsAdminCreatePage } from 'domains/collections/pages/admin/CollectionsAdminCreatePage'
import { CollectionsAdminEditPage } from 'domains/collections/pages/admin/CollectionsAdminEditPage'
import { CollectionsAdminViewPage } from 'domains/collections/pages/admin/CollectionsAdminViewPage'
import { DomainRoute } from 'domains/collections/utils/domain/routingComponents'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'

export const collectionsAdminRouter = (
  <DomainRoute route="app-admin-collections" accessControl={collectionsAdminAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="app-admin-collections-list" component={CollectionsAdminListPage} />
      <DomainRoute exact route="app-admin-collections-new" component={CollectionsAdminCreatePage} />
      <DomainRoute exact route="app-admin-collections-edit" component={CollectionsAdminEditPage} />
      <DomainRoute exact route="app-admin-collections-show" component={CollectionsAdminViewPage} />
    </DashSwitch>
  </DomainRoute>
)
